import React, { useState } from 'react';
import { Container, Form, Wrapper, BrandLogo, Error as ErrorComponent } from '../../styles';
import { Input, SubmitButton } from './styles';
import { awsAuthService } from '../../utils/awsAuth';

const SignIn: React.FC = () => {
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Wrapper>
      <BrandLogo>
        <svg
          width="118"
          height="105"
          viewBox="0 0 118 105"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" width="117" height="104.606" fill="url(#pattern0_13811_25198)" />
        </svg>
      </BrandLogo>
      <Container>
        <h1>Admin Sign In</h1>
        <Form
          onSubmit={async (e: React.SyntheticEvent) => {
            e.preventDefault();
            setError('');
            setIsLoading(true);
            
            const target = e.target as typeof e.target & {
              email: { value: string };
              password: { value: string };
            };
            const email = target.email.value;
            const password = target.password.value;
            
            try {
              // AWS-only authentication - no Realm fallback
              console.log('🔐 Attempting AWS authentication...');
              await awsAuthService.login({ email, password });
              console.log('✅ AWS authentication successful');
              
              // Force hard navigation to ensure router picks up auth state
              window.location.href = '/admin/portal';
              
            } catch (e: any) {
              console.error('❌ AWS Login failed:', e);
              setError(e?.message || e?.error || 'AWS authentication failed');
              
              // Clear any partial authentication state
              awsAuthService.logout();
            } finally {
              setIsLoading(false);
            }
          }}
        >
          {error && <ErrorComponent>{error}</ErrorComponent>}
          <Input placeholder="Email" type="email" name="email" required />
          <Input placeholder="Password" type="password" name="password" required />
          <SubmitButton type="submit" value={isLoading ? "Logging in..." : "Log in"} disabled={isLoading} />
        </Form>
      </Container>
    </Wrapper>
  );
};

export { SignIn };
